import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import { Apollo, Mutation } from "apollo-angular";


export class CreateIndicatorCalculationInput {
  indicator: string;
  reductionType: string;
  metric: string;
  conversionFactor: number;
}

export type CreateIndicatorCalculationMutationVariables = {
  input: CreateIndicatorCalculationInput;
};

export type CreateIndicatorCalculationMutation = {
  createIndicatorCalculation: {
    id: string; 
  };
};


export const CreateIndicatorCalculationDocument = gql`
  mutation CreateIndicatorCalculation($input: CreateIndicatorCalculationDto!) {
    createIndicatorCalculation(data: $input) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateIndicatorCalculationGQL extends Mutation<
  CreateIndicatorCalculationMutation,
  CreateIndicatorCalculationMutationVariables
> {
  document = CreateIndicatorCalculationDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}
